import React from 'react';
import { Clock, Check, AlertCircle, Shield, Beaker, User, Star, AlertTriangle } from 'lucide-react';
export function ZenturaLanding() {
  return <div className="min-h-screen bg-white text-[#333] font-sans leading-relaxed selection:bg-[#e67e22] selection:text-white" data-id="element-2">
      <style data-id="element-3">{`
        @import url('https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
        
        .font-merriweather {
          font-family: 'Merriweather', serif;
        }
        .font-opensans {
          font-family: 'Open Sans', sans-serif;
        }
      `}</style>

      {/* Top Banner */}
      <div className="bg-[#2d5a27] text-white text-center py-3 px-5 text-sm font-semibold tracking-wide" data-id="element-4">
        DISCOVER THE SOLUTION -{' '}
        <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="underline hover:text-gray-200 transition-colors" data-id="element-5">
          SHOP NOW
        </a>
      </div>

      <div className="max-w-[750px] mx-auto px-5 font-opensans" data-id="element-6">
        {/* Header Section */}
        <div className="pt-8 pb-5" data-id="element-7">
          <div className="inline-flex items-center gap-2 text-[#2d5a27] text-sm font-semibold mb-4 bg-green-50 px-3 py-1 rounded-full" data-id="element-8">
            <Beaker className="w-4 h-4" data-id="element-9" />
            Based on Clinical Research
          </div>

          <h1 className="font-merriweather text-3xl md:text-4xl font-bold leading-tight text-[#1a1a1a] mb-3" data-id="element-10">
            The Hidden Invaders Living Inside 85% Of People{' '}
            <span className="text-[#e67e22]" data-id="element-11">Right Now</span>
          </h1>

          <p className="italic text-[#555] text-lg mb-5" data-id="element-12">
            And the Natural Solution Thousands Are Using to Destroy Them
          </p>

          <div className="flex flex-wrap items-center gap-4 mb-4" data-id="element-13">
            <div className="flex items-center gap-3" data-id="element-14">
              <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/Untitled_design_77_668829a3-dc6e-4d3d-b1ec-9ef0184b067f.png?v=1764818562" alt="Jonathan Foster" className="w-11 h-11 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-15" />
              <div className="text-sm" data-id="element-16">
                By{' '}
                <span className="text-[#2d5a27] font-semibold" data-id="element-17">
                  Jonathan Foster
                </span>
                <span className="mx-2 text-gray-400" data-id="element-18">|</span>
                June 27, 2025
              </div>
            </div>

            <div className="inline-flex items-center gap-1.5 border border-[#2d5a27] text-[#2d5a27] px-3 py-1.5 rounded-full text-xs font-medium" data-id="element-19">
              <Clock className="w-3.5 h-3.5" data-id="element-20" />
              Estimated{' '}
              <span className="text-[#e67e22] font-bold" data-id="element-21">5-7 Minute Read</span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-[3px] w-full bg-gradient-to-r from-[#e67e22] to-[#f5a623] my-6 rounded-full opacity-80" data-id="element-22"></div>

        {/* Before/After Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 my-8" data-id="element-23">
          <div className="relative group overflow-hidden rounded-lg shadow-md" data-id="element-24">
            <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/99b80af4-5fed-4e40-86c0-84f14d3b771e.png?v=1764735923" alt="Before" className="w-full h-auto block transform group-hover:scale-105 transition-transform duration-500" data-id="element-25" />
            <div className="absolute bottom-0 left-0 right-0 bg-gray-900/80 text-white text-center py-2 font-semibold text-sm backdrop-blur-sm" data-id="element-26">
              Before
            </div>
          </div>
          <div className="relative group overflow-hidden rounded-lg shadow-md" data-id="element-27">
            <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/1_365712de-75d2-4946-933f-ba7435e010b7.png?v=1764813779" alt="After" className="w-full h-auto block transform group-hover:scale-105 transition-transform duration-500" data-id="element-28" />
            <div className="absolute bottom-0 left-0 right-0 bg-[#2d5a27]/90 text-white text-center py-2 font-semibold text-sm backdrop-blur-sm" data-id="element-29">
              After
            </div>
          </div>
        </div>

        {/* Story Intro */}
        <div className="prose prose-lg max-w-none text-[#333]" data-id="element-30">
          <p className="mb-5 text-[17px]" data-id="element-31">
            Lisa thought her chronic sinus infections and afternoon energy
            crashes were just bad luck.
          </p>
          <p className="mb-5 text-[17px]" data-id="element-32">
            This 38 year old teacher had been dealing with them for so long,
            she'd accepted them as normal.
          </p>
          <p className="mb-5 text-[17px]" data-id="element-33">
            The twice-yearly antibiotics for her sinuses. The 2 PM slump that
            made her reach for her third cup of coffee. The bloating that made
            her look six months pregnant by evening.
          </p>
        </div>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/2_0f0eea6c-651a-4066-814d-173df0805098.png?v=1764813778" alt="Woman with coffee" className="w-full max-w-[600px] mx-auto block my-6 rounded-xl shadow-sm" data-id="element-34" />

        <div className="my-8 pl-6 border-l-4 border-[#e67e22] italic" data-id="element-35">
          <p className="text-xl font-semibold text-[#e67e22] mb-2" data-id="element-36">
            "I just figured this was my life now,"{' '}
            <span className="text-[#333] font-normal" data-id="element-37">she admits.</span>
          </p>
          <p className="text-xl font-semibold text-[#e67e22]" data-id="element-38">
            "I was too young to feel so old, but what else could I do?"
          </p>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-39">
          But Lisa's "bad luck" wasn't random at all. And she's not alone…
        </p>

        {/* Symptoms Section */}
        <div className="bg-[#fef9f3] p-8 -mx-5 md:rounded-xl md:mx-0 my-10 border border-orange-100" data-id="element-40">
          <h2 className="font-merriweather text-2xl md:text-[28px] font-bold text-[#1a1a1a] text-center mb-2" data-id="element-41">
            Look, The Symptoms You Think Are Normal... Aren't
          </h2>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-42">Do any of these sound familiar?</p>

        <div className="space-y-4 my-8" data-id="element-43">
          {[{
          icon: '😴',
          text: 'Exhausted by afternoon, even if you got 8+ hours of sleep'
        }, {
          icon: '🫄',
          text: 'Bloating so bad you have to unbutton your pants after eating'
        }, {
          icon: '🧠',
          text: 'Brain fog that makes you forget why you walked into a room'
        }, {
          icon: '😕',
          text: "Random breakouts at 35 when you haven't had acne since high school"
        }, {
          icon: '🤧',
          text: 'Sinus infections every few months, or weeks, like clockwork'
        }, {
          icon: '🍬',
          text: 'Sugar cravings that feel impossible to control'
        }, {
          icon: '⚖️',
          text: "Stubborn fat, especially around your tummy, that just won't budge"
        }].map((item, i) => <div key={i} className="flex items-start gap-4 p-4 bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-44">
              <div className="w-10 h-10 min-w-[40px] bg-gradient-to-br from-[#ffecd2] to-[#fcb69f] rounded-full flex items-center justify-center text-xl shadow-inner" data-id="element-45">
                {item.icon}
              </div>
              <div className="text-base text-[#333] pt-2" data-id="element-46">{item.text}</div>
            </div>)}
        </div>

        <p className="mb-5 text-[17px]" data-id="element-47">
          Most people experience at least three of these symptoms regularly.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-48">
          They blame age, stress, or genetics. They try different diets,
          supplements, or medications to address each problem separately.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-49">
          But what if all these problems had the same hidden source?
        </p>

        <div className="bg-white border border-gray-100 rounded-xl p-6 my-8 text-center shadow-sm" data-id="element-50">
          <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/health_marker.webp?v=1764815245" alt="Health Marker Chart" className="max-w-full h-auto mx-auto" data-id="element-51" />
        </div>

        <p className="mb-5 text-[17px]" data-id="element-52">
          What if scientific research shows that millions of people are walking
          around with an invasion happening inside their bodies right now – and
          they have no idea?
        </p>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/3_0a974500-6136-421b-88b2-d8bed6b52001.png?v=1764813778" alt="Test Results" className="w-full rounded-xl my-6 shadow-sm" data-id="element-53" />

        {/* Silent War Section */}
        <h2 className="font-merriweather text-[26px] font-bold text-[#1a1a1a] mt-10 mb-6" data-id="element-54">
          The Silent War Inside Your Body
        </h2>

        <p className="mb-5 text-[17px]" data-id="element-55">
          If you've experienced at least two of the symptoms I mentioned before…
        </p>
        <p className="mb-5 text-[17px]" data-id="element-56">Then here's what's really happening.</p>
        <p className="mb-5 text-[17px]" data-id="element-57">
          <strong data-id="element-58">
            Your gut is infested with millions of tiny 'invaders'.
          </strong>
        </p>
        <p className="mb-5 text-[17px]" data-id="element-59">
          You see, according to the CDC (Centers for Disease Control and
          Prevention) over half of "healthy" people around the world are
          carrying around high levels of fungus, parasites, and bad bacteria in
          their stomachs right now.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-60">And they have no clue…</p>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/4_57205fd6-2290-47b3-906c-34d347ee1194.png?v=1764813777" alt="Nutrient Chart" className="w-full rounded-xl my-6 shadow-sm" data-id="element-61" />

        <p className="mb-5 text-[17px]" data-id="element-62">
          Medical researchers from Oxford University found that these nasty
          little invaders are literally living inside you, doing damage 24/7
        </p>
        <p className="mb-5 text-[17px]" data-id="element-63">They are literally:</p>

        <div className="space-y-4 my-6" data-id="element-64">
          {[{
          title: 'Eating YOUR food',
          text: "That's why you're always craving sugar"
        }, {
          title: 'Pooping out toxins',
          text: 'Making you FEEL like garbage'
        }, {
          title: 'Causing inflammation',
          text: 'Weakening your joints, especially your knees'
        }, {
          title: 'Messing with your hormones',
          text: "So you're always feeling 'off'"
        }, {
          title: 'Attacking your immune system',
          text: 'Which is why you catch every bug going around'
        }].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-65">
              <div className="w-7 h-7 min-w-[28px] bg-[#e74c3c] rounded-full flex items-center justify-center text-white font-bold text-sm shadow-sm" data-id="element-66">
                !
              </div>
              <div data-id="element-67">
                <span className="font-bold text-[#1a1a1a]" data-id="element-68">{item.title}</span> -{' '}
                {item.text}
              </div>
            </div>)}
        </div>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/5_c4fd5f74-1904-4453-ae68-e37c155ec804.png?v=1764813778" alt="Parasites Illustration" className="w-full rounded-xl my-6 shadow-sm" data-id="element-69" />

        <p className="mb-5 text-[17px]" data-id="element-70">
          It's like having freeloaders in your house who eat all your food,
          trash the place, and never leave.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-71">
          No wonder you're exhausted, bloated all the time, and can never lose
          weight.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-72">
          You see, it's actually not your fault.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-73">
          Because your body is under attack from the inside… and you didn't even
          know it.
        </p>

        {/* Fortress Section */}
        <div className="bg-[#fef9f3] p-8 -mx-5 md:rounded-xl md:mx-0 my-10 border border-orange-100 text-center" data-id="element-74">
          <h2 className="font-merriweather text-[28px] font-bold text-[#1a1a1a] mb-2" data-id="element-75">
            They Shouldn't Be Able To Live In Your Body…
          </h2>
          <p className="font-bold mt-2 text-lg text-[#e67e22]" data-id="element-76">
            But There's A Fortress That Protects Them
          </p>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-77">
          <strong data-id="element-78">Here's what makes it even worse...</strong>
        </p>
        <p className="mb-5 text-[17px]" data-id="element-79">
          These parasites have figured out how to hide from everything you throw
          at them.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-80">
          Scientists discovered they build something called a "bio film" -
          basically a protective slime shield around themselves. (Think of that
          gross film on your teeth when you wake up - but in your gut.)
        </p>
        <p className="mb-5 text-[17px]" data-id="element-81">
          This slimy shield makes them practically bulletproof.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-82">
          Medical studies show it makes them 1,000 times harder to kill.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-83">
          Yes, you read that right. A thousand times harder.
        </p>

        <div className="my-8 text-center" data-id="element-84">
          <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/6_d794d5e4-a009-418a-8fe0-a9c3cbc95383.png?v=1764813777" alt="Parasite Shield" className="w-full max-w-[600px] mx-auto block rounded-lg" data-id="element-85" />
        </div>

        <p className="mb-5 text-[17px]" data-id="element-86">
          It's like trying to clean mold that's been painted over. You can scrub
          all day long, but you're never getting to the real problem underneath.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-87">
          That's why nothing you've tried has worked to fix those symptoms.
        </p>

        <div className="bg-white border border-gray-200 rounded-xl p-6 my-8 shadow-sm" data-id="element-88">
          {[{
          icon: '💊',
          title: 'Probiotics for bloating?',
          result: 'Bounce right off the slime shield.'
        }, {
          icon: '🥗',
          title: 'Keto diet for weight loss?',
          result: 'They just wait it out.'
        }, {
          icon: '💉',
          title: 'Antibiotics for sinus infections?',
          result: "Can't penetrate their fortress at all."
        }, {
          icon: '🧃',
          title: 'Detox cleanses for fatigue?',
          result: 'Parasites remain untouched.'
        }].map((item, i, arr) => <div key={i} className={`flex items-start gap-4 pb-5 mb-5 ${i !== arr.length - 1 ? 'border-b border-gray-100' : 'pb-0 mb-0'}`} data-id="element-89">
              <div className="w-11 h-11 min-w-[44px] bg-gradient-to-br from-[#ffecd2] to-[#fcb69f] rounded-full flex items-center justify-center text-xl shadow-sm" data-id="element-90">
                {item.icon}
              </div>
              <div data-id="element-91">
                <div className="font-bold text-[#1a1a1a] mb-1" data-id="element-92">
                  {item.title}
                </div>
                <div className="text-[#666] text-[15px]" data-id="element-93">{item.result}</div>
              </div>
            </div>)}
        </div>

        <p className="mb-5 text-[17px]" data-id="element-94">
          These parasites literally hide behind their slime wall, laughing while
          you waste hundreds on useless treatments. And when you give up, they
          come back stronger.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-95">
          It's like they've built a fortress in your gut…
        </p>
        <p className="mb-5 text-[17px]" data-id="element-96">
          And they will NOT leave without a fight.
        </p>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/7_6047e306-3dce-49fb-aca5-cd5fbbcf5ba3.png?v=1764813779" alt="Parasite Character" className="w-full rounded-xl my-6 shadow-sm" data-id="element-97" />

        {/* Discovery Section */}
        <div className="bg-[#fef9f3] p-8 -mx-5 md:rounded-xl md:mx-0 my-10 border border-orange-100" data-id="element-98">
          <h2 className="font-merriweather text-[28px] font-bold text-[#1a1a1a] text-center" data-id="element-99">
            The Discovery That Changes Everything
          </h2>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-100">
          This is where Lisa's story takes a turn that could change yours too.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-101">
          After years of just "dealing with it," Lisa found something that
          actually worked.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-102">
          She discovered a medical study that shocked her:
        </p>

        <div className="font-merriweather italic text-[22px] font-bold text-[#e67e22] my-8 leading-snug" data-id="element-103">
          Doctors from Oxford University conducted a study on 14 people with
          confirmed parasites in their body.
        </div>

        <p className="mb-5 text-[17px]" data-id="element-104">
          Medical researchers from Oxford University found that these nasty
          little invaders are literally living inside you, doing damage 24/7
        </p>
        <p className="mb-5 text-[17px]" data-id="element-105">They are literally:</p>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/micoscope.webp?v=1764815904" alt="Microscope" className="w-full rounded-xl my-6 shadow-sm" data-id="element-106" />

        <p className="mb-5 text-[17px]" data-id="element-107">
          They gave them 600 milligrams of oregano oil, every single day, for 6
          weeks straight.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-108">The results were shocked.</p>

        <div className="bg-gray-50 p-5 border-l-4 border-[#e67e22] my-6 text-lg rounded-r-lg" data-id="element-109">
          <strong data-id="element-110">
            77% of these 14 people completely eliminated their parasites.
          </strong>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-111">Not reduced, not improved…</p>
        <p className="text-xl font-semibold text-center my-8 text-[#1a1a1a]" data-id="element-112">
          ELIMINATED.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-113">
          And even better - the people who'd been suffering with bloating,
          exhaustion, and stomach problems for YEARS finally got relief.
        </p>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/8_20c6e2fc-caa2-4f08-8e82-eefb1b5a0897.png?v=1764813778" alt="Before and After" className="w-full rounded-xl my-6 shadow-sm" data-id="element-114" />

        <p className="mb-5 text-[17px]" data-id="element-115">
          One patient had dealt with chronic fatigue for over a decade. Six
          weeks later, their energy was almost fully restored.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-116">
          Another one of them had bloating so bad she looked pregnant.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-117">
          And again, six weeks later, her stomach was now almost flat.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-118">
          But here's where it gets interesting…
        </p>
        <p className="mb-5 text-[17px]" data-id="element-119">
          The oregano oil that was given to these patients wasn't just ANY
          oregano oil.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-120">
          It contained something called carvacrol - that's the parasite-killing
          compound in oregano.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-121">
          And here's what nobody tells you:{' '}
          <strong data-id="element-122">concentration is EVERYTHING.</strong>
        </p>
        <p className="mb-5 text-[17px]" data-id="element-123">
          Most oregano oil at the health store is pathetically weak.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-124">
          They only 30-50% carvacrol, even if they claim to contain more.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-125">
          That's like trying to clean your oven with dish soap. Sure, it's
          "cleaning product" - but it's not strong enough for the real mess.
        </p>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/9_3576d7ee-5d95-49f6-9078-899a5bcd02dd.png?v=1764813777" alt="Oregano" className="w-full rounded-xl my-6 shadow-sm" data-id="element-126" />

        <p className="mb-5 text-[17px]" data-id="element-127">
          The oregano oil that actually eliminated parasites in these studies
          contained <strong data-id="element-128">85% carvacrol</strong>. That's pharmaceutical
          strength.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-129">
          Nearly DOUBLE what you'll find on store shelves.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-130">
          Because at 85% concentration, it literally melts through the biofilm -
          that protective slime shield the parasites hide behind.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-131">
          Think of it like this: 30% concentration is a gentle rain on an
          umbrella. 85% concentration is a fire hose that blasts the umbrella
          away. Once that shield is gone, the parasites are sitting ducks.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-132">
          They are exposed and defenseless, ready to be flushed out of your
          system.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-133">
          So how do you ACTUALLY get them out of your body for good?
        </p>

        {/* Two-Step Attack Section */}
        <div className="bg-[#fef9f3] p-8 -mx-5 md:rounded-xl md:mx-0 my-10 border border-orange-100" data-id="element-134">
          <h2 className="font-merriweather text-[28px] font-bold text-[#1a1a1a] text-center" data-id="element-135">
            The Two-Step Attack That's Saving Thousands Of Lives
          </h2>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-136">Remember Lisa?</p>
        <p className="mb-5 text-[17px]" data-id="element-137">
          She discovered that killing parasites is only half the battle. You
          also need to flush out the dead parasites, toxins, and debris - or
          you'll feel even worse as they rot inside you.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-138">
          That's why the most effective approach uses TWO powerful oils working
          together:
        </p>

        <div className="space-y-6 my-8" data-id="element-139">
          <div className="bg-[#fef9f3] border-2 border-[#e67e22] rounded-xl p-5 shadow-sm" data-id="element-140">
            <div className="flex items-center gap-3 mb-3" data-id="element-141">
              <span className="text-2xl" data-id="element-142">🌿</span>
              <span className="font-bold text-[#e67e22] text-lg" data-id="element-143">
                First: 85% Carvacrol Oregano Oil
              </span>
              <span className="text-[#333]" data-id="element-144">
                - This is your parasite assassin.
              </span>
            </div>
            <p className="text-[15px] m-0" data-id="element-145">
              At 85% concentration, it melts through bio films and kills
              parasites, candida, and bad bacteria on contact. Think of it as
              your demolition crew.
            </p>
          </div>

          <div className="bg-[#fef9f3] border-2 border-[#e67e22] rounded-xl p-5 shadow-sm" data-id="element-146">
            <div className="flex items-center gap-3 mb-3" data-id="element-147">
              <span className="text-2xl" data-id="element-148">🖤</span>
              <span className="font-bold text-[#e67e22] text-lg" data-id="element-149">
                Second: Black Seed Oil
              </span>
              <span className="text-[#333]" data-id="element-150">- This is your cleanup crew.</span>
            </div>
            <p className="text-[15px] m-0" data-id="element-151">
              As the oregano oil kills the invaders, black seed oil flushes out
              the corpses and toxins. It also calms inflammation and helps your
              gut heal.
            </p>
          </div>
        </div>

        <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/10_2f31c4fa-ae84-4d46-a5ef-5a6ab7832f3d.png?v=1764813776" alt="Gut Healing" className="w-full rounded-xl my-6 shadow-sm" data-id="element-152" />

        <p className="mb-5 text-[17px]" data-id="element-153">
          Studies show it's so powerful it works as well as triple antibiotic
          therapy - without the side effects.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-154">
          Together, they're like a one-two punch that parasites can't survive.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-155">
          Mark Rodriguez discovered this combination after wasting 10 years on
          useless treatments.
        </p>

        <div className="my-8 pl-6 border-l-4 border-[#e67e22] italic" data-id="element-156">
          <p className="text-xl font-semibold text-[#e67e22] leading-relaxed" data-id="element-157">
            "I tried everything - B12 shots, thyroid meds, $500 functional
            medicine visits. Nothing worked because they were treating symptoms,
            not the parasites causing them. One week after starting both oils, I
            felt human again. Like someone flipped a switch inside of me."
          </p>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-158">
          While you're spending thousands on band-aid solutions, the real
          problem keeps getting worse...
        </p>

        {/* Solution Section */}
        <div className="bg-[#fef9f3] p-8 -mx-5 md:rounded-xl md:mx-0 my-10 border border-orange-100" data-id="element-159">
          <h2 className="font-merriweather text-[28px] font-bold text-[#1a1a1a] text-center" data-id="element-160">
            Finally, A Solution That Actually Works
          </h2>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-161">
          Remember that Oxford study I mentioned?
        </p>
        <p className="mb-5 text-[17px]" data-id="element-162">
          Where 77% of people eliminated their parasites?
        </p>
        <p className="mb-5 text-[17px]" data-id="element-163">
          Well, one company took that exact formula - 85% carvacrol oregano oil
          - and combined it with black seed oil to create the perfect
          parasite-destroying combo.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-164">
          It's called{' '}
          <strong data-id="element-165">
            <u data-id="element-166">
              <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="text-inherit hover:text-[#e67e22] transition-colors" data-id="element-167">
                Zentura™ Oil of Oregano Softgels
              </a>
            </u>
          </strong>
          .
        </p>

        <div className="text-center my-8" data-id="element-168">
          <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/11_57a549ef-b94a-4928-b052-8a49d10511e5.png?v=1764813777" alt="Zentura Oil of Oregano" className="w-full max-w-[500px] mx-auto block rounded-xl shadow-md" data-id="element-169" />
        </div>

        <p className="mb-5 text-[17px]" data-id="element-170">And it's changing lives.</p>
        <p className="mb-5 text-[17px]" data-id="element-171">
          Unlike the weak oregano oil at health stores, Zentura contains the
          same pharmaceutical-grade 85% carvacrol from the study.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-172">
          Plus black seed oil to flush out the dead parasites and heal your gut.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-173">The best part?</p>
        <p className="mb-5 text-[17px]" data-id="element-174">
          It's not some sketchy supplement made in someone's garage.
        </p>

        <div className="text-center my-8" data-id="element-175">
          <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/12_4cb2cc20-22c3-4b20-8f4a-2d776eb81d19.png?v=1764813778" alt="Man holding Zentura" className="max-w-full rounded-xl shadow-md" data-id="element-176" />
        </div>

        <div className="bg-white my-8 border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-177">
          {[{
          icon: '🔬',
          text: 'Third-party tested to guarantee 85% carvacrol (most brands lie about their concentration)'
        }, {
          icon: '🇺🇸',
          text: 'Made in the USA'
        }, {
          icon: '👥',
          text: 'Over 5,000 people have already used it to reclaim their health'
        }].map((item, i) => <div key={i} className="flex items-center gap-4 p-5 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors" data-id="element-178">
              <div className="text-2xl" data-id="element-179">{item.icon}</div>
              <div className="font-semibold text-[#333]" data-id="element-180">{item.text}</div>
            </div>)}
        </div>

        <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="block bg-[#e67e22] text-white text-center py-5 px-8 text-lg font-bold rounded-lg uppercase tracking-wide hover:bg-[#d35400] transition-all transform hover:-translate-y-1 shadow-lg my-10" data-id="element-181">
          TRY ZENTURA RISK-FREE FOR 60 DAYS
        </a>

        {/* Testimonials */}
        <h2 className="font-merriweather text-[26px] font-bold text-[#1a1a1a] text-center mt-12 mb-8" data-id="element-182">
          Real People, Real Results
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12" data-id="element-183">
          {[{
          name: 'Rebecca T.',
          img: 'https://cdn.shopify.com/s/files/1/0608/4408/1231/files/13_34407b4f-1a5b-48db-a6ae-ae7f7298002f.png?v=1764813779',
          text: "My sinus infections were like clockwork - every 3 months. I'm 8 months into taking Zentura and haven't had ONE. My ENT asked what changed."
        }, {
          name: 'David L.',
          img: 'https://cdn.shopify.com/s/files/1/0608/4408/1231/files/14_700a47a6-3c3a-408a-9995-4df38ce88fe5.png?v=1764813779',
          text: "The brain fog was so bad I forgot my daughter's parent-teacher conference. Two weeks on Zentura and I feel like someone cleaned the cobwebs out of my brain."
        }, {
          name: 'Jennifer M.',
          img: 'https://cdn.shopify.com/s/files/1/0608/4408/1231/files/15_8ee2168a-2963-4a56-ba1e-aa49bc4258c3.png?v=1764813778',
          text: 'Down 14 pounds without changing anything. When parasites stop stealing your nutrients, your body actually burns fat like it should.'
        }].map((item, i) => <div key={i} className="bg-white border border-gray-200 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-184">
              <img src={item.img} alt={item.name} className="w-20 h-20 rounded-full mx-auto mb-4 object-cover border-2 border-gray-100" data-id="element-185" />
              <div className="text-4xl text-[#e67e22] leading-none mb-2 font-serif" data-id="element-186">
                "
              </div>
              <div className="italic text-[#555] text-sm mb-4 leading-relaxed min-h-[80px]" data-id="element-187">
                "{item.text}"
              </div>
              <div className="flex items-center justify-center gap-2 text-[13px] text-gray-500 font-medium" data-id="element-188">
                <Check className="w-4 h-4 text-[#2d5a27]" data-id="element-189" />
                {item.name} | Verified Buyer
              </div>
            </div>)}
        </div>

        {/* What Nobody Tells You */}
        <h2 className="font-merriweather text-[26px] font-bold text-[#1a1a1a] mt-10 mb-6" data-id="element-190">
          Here's What Nobody Tells You
        </h2>

        <p className="mb-5 text-[17px]" data-id="element-191">
          When you start killing parasites, they release toxins as they die.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-192">
          Some people feel tired or get loose stools for a few days.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-193">This is actually GOOD NEWS.</p>
        <p className="mb-5 text-[17px]" data-id="element-194">
          It means they're dying and your body is flushing them out.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-195">
          Most people start feeling better within 3-7 days. By week 3 is when
          the transformation happens.
        </p>

        <div className="text-center my-8" data-id="element-196">
          <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/16.png?v=1764813779" alt="Woman with Zentura" className="max-w-full rounded-xl shadow-md" data-id="element-197" />
        </div>

        <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="block bg-[#e67e22] text-white text-center py-5 px-8 text-lg font-bold rounded-lg uppercase tracking-wide hover:bg-[#d35400] transition-all transform hover:-translate-y-1 shadow-lg my-10" data-id="element-198">
          TRY ZENTURA RISK-FREE FOR 60 DAYS
        </a>

        {/* Body Begging Section */}
        <h2 className="font-merriweather text-[26px] font-bold text-[#1a1a1a] mt-10 mb-6" data-id="element-199">
          Your Body Is Begging You To Listen
        </h2>

        <p className="mb-5 text-[17px]" data-id="element-200">
          Right now, your body is sending you signals. Those symptoms aren't
          random. They're not "just aging."
        </p>
        <p className="mb-5 text-[17px]" data-id="element-201">They're WARNING SIGNS.</p>
        <p className="mb-5 text-[17px]" data-id="element-202">Every day you ignore them:</p>

        <div className="space-y-3 my-6" data-id="element-203">
          {['The parasites multiply', 'The bio film gets thicker', 'You lose more nutrients', 'You feel worse and worse'].map((text, i) => <div key={i} className="flex items-center gap-3 font-semibold text-[#333]" data-id="element-204">
              <div className="w-6 h-6 bg-[#e74c3c] rounded-full flex items-center justify-center text-white text-xs font-bold shadow-sm" data-id="element-205">
                !
              </div>
              <span data-id="element-206">{text}</span>
            </div>)}
        </div>

        <p className="mb-5 text-[17px]" data-id="element-207">
          But imagine waking up with REAL energy. Not needing coffee to
          function.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-208">Eating without bloating.</p>
        <p className="mb-5 text-[17px]" data-id="element-209">Thinking clearly.</p>
        <p className="mb-5 text-[17px]" data-id="element-210">
          Looking in the mirror and seeing clear skin and bright eyes.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-211">
          That's what life is like when the parasites are gone.
        </p>

        <div className="text-center my-8" data-id="element-212">
          <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/17_80946ec6-730c-451b-bbcc-336e13fa6f90.png?v=1764813779" alt="Skin Before and After" className="max-w-full rounded-xl shadow-md" data-id="element-213" />
        </div>

        <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="block bg-[#e67e22] text-white text-center py-5 px-8 text-lg font-bold rounded-lg uppercase tracking-wide hover:bg-[#d35400] transition-all transform hover:-translate-y-1 shadow-lg my-10" data-id="element-214">
          TRY ZENTURA RISK-FREE FOR 60 DAYS
        </a>

        {/* Decision Section */}
        <div className="bg-[#fef9f3] p-8 -mx-5 md:rounded-xl md:mx-0 my-10 border border-orange-100" data-id="element-215">
          <h2 className="font-merriweather text-[28px] font-bold text-[#1a1a1a] text-center" data-id="element-216">
            The Decision That Changed Everything
          </h2>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-217">
          Lisa made her decision after years of suffering.
        </p>

        <div className="my-8 pl-6 border-l-4 border-[#e67e22] italic" data-id="element-218">
          <p className="text-xl font-semibold text-[#e67e22] leading-relaxed" data-id="element-219">
            "I'd already spent hundreds on doctors, tests, supplements that
            didn't work. What's another $30? Especially with a money-back
            guarantee."
          </p>
        </div>

        <p className="mb-5 text-[17px]" data-id="element-220">
          Ten days later, her energy started returning. Three weeks later, the
          sinus infections stopped.
        </p>
        <p className="mb-5 text-[17px]" data-id="element-221">Six months later:</p>

        <div className="my-8 pl-6 border-l-4 border-[#e67e22] italic" data-id="element-222">
          <p className="text-xl font-semibold text-[#e67e22] leading-relaxed" data-id="element-223">
            "I FEEL 10 years younger. I didn't realize how sick I was until I
            got better."
          </p>
        </div>

        <div className="text-center my-8" data-id="element-224">
          <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/18.png?v=1764813779" alt="Lisa with Zentura" className="max-w-full rounded-xl shadow-md" data-id="element-225" />
        </div>

        <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="block bg-[#e67e22] text-white text-center py-5 px-8 text-lg font-bold rounded-lg uppercase tracking-wide hover:bg-[#d35400] transition-all transform hover:-translate-y-1 shadow-lg my-10" data-id="element-226">
          TRY ZENTURA RISK-FREE FOR 60 DAYS
        </a>

        {/* Final CTA Section */}
        <div className="bg-[#fef9f3] p-10 -mx-5 md:rounded-xl md:mx-0 my-10 border border-orange-100 text-center" data-id="element-227">
          <h2 className="font-merriweather text-[28px] font-bold text-[#1a1a1a] mb-6" data-id="element-228">
            It's Time To Evict The Freeloaders
          </h2>

          <p className="mb-5 text-[17px] text-left" data-id="element-229">
            Look, those parasites in your gut aren't going anywhere on their
            own.
          </p>
          <p className="mb-5 text-[17px] text-left" data-id="element-230">
            They've got a good thing going - free food, protection behind their
            slime shield, and a warm place to live.
          </p>
          <p className="mb-5 text-[17px] text-left" data-id="element-231">
            You can keep treating the symptoms while they party in your gut.
          </p>
          <p className="mb-5 text-[17px] text-left" data-id="element-232">
            Or you can kick them out once and for all.
          </p>

          <div className="text-center my-8" data-id="element-233">
            <img src="https://cdn.shopify.com/s/files/1/0608/4408/1231/files/19_1cbd1bb6-8833-4e08-a99d-7dba96b0ef1a.png?v=1764813776" alt="Zentura Product" className="max-w-full rounded-xl shadow-md inline-block" data-id="element-234" />
          </div>

          <p className="mb-5 text-[17px] text-left" data-id="element-235">
            Zentura comes with a 60-day money-back guarantee because once you
            feel what it's like to be parasite-free, you'll never want to go
            back.
          </p>

          <div className="text-xl font-semibold text-[#e67e22] italic my-6" data-id="element-236">
            Don't wait another day. Your health is too important.
          </div>

          <p className="mb-8 text-[17px] text-left" data-id="element-237">
            <strong data-id="element-238">
              Order{' '}
              <u data-id="element-239">
                <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="text-inherit hover:text-[#e67e22] transition-colors" data-id="element-240">
                  Zentura™ Oil of Oregano Softgels
                </a>
              </u>{' '}
              Now
            </strong>{' '}
            - The only parasite cleanse with pharmaceutical-grade 85% carvacrol.
          </p>

          <a href="https://shop-zentura.com/products/oil-of-oregano-softgels" className="block bg-[#e67e22] text-white text-center py-5 px-8 text-lg font-bold rounded-lg uppercase tracking-wide hover:bg-[#d35400] transition-all transform hover:-translate-y-1 shadow-lg" data-id="element-241">
            TRY ZENTURA RISK-FREE FOR 60 DAYS
          </a>
        </div>

        {/* PS Section */}
        <div className="bg-gray-50 p-6 rounded-lg my-8 italic text-[#555] text-[15px] leading-relaxed border border-gray-200" data-id="element-242">
          <strong data-id="element-243">P.S.</strong> CDC research shows over half of people are
          carrying these parasites RIGHT NOW. If you have 3 or more symptoms
          from the list above, you're probably one of them. Zentura uses the
          same 85% carvacrol concentration that eliminated parasites in 77% of
          study participants. Most customers report feeling better within the
          first week. But supplies are limited - we can only produce so much
          true 85% carvacrol oil. Don't let another day go by feeling tired,
          bloated, and sick. Order now while it's still in stock.
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#333] text-[#999] py-12 px-5 mt-12" data-id="element-244">
        <div className="max-w-[750px] mx-auto" data-id="element-245">
          <div className="text-2xl font-bold text-white mb-5 tracking-wider" data-id="element-246">
            INNERCHARGE
          </div>

          <p className="text-[13px] leading-relaxed mb-4" data-id="element-247">
            This content is provided for general informational purposes only and
            is not intended as medical advice, diagnosis, or treatment. Always
            consult with a qualified healthcare professional before starting any
            new supplement, health routine, or treatment plan. Individual
            results may vary.
          </p>

          <p className="text-[13px] leading-relaxed mb-4" data-id="element-248">
            The views expressed in this article are those of the individual and
            do not necessarily reflect the opinions or claims of the product's
            manufacturer.
          </p>

          <p className="text-[13px] leading-relaxed mb-4" data-id="element-249">
            All trademarks and copyrights are the property of their respective
            owners.
          </p>

          <p className="text-[13px] pt-5 mt-5 border-t border-[#444]" data-id="element-250">
            © 2025 InnerCharge
          </p>
        </div>
      </footer>
    </div>;
}